document.addEventListener('DOMContentLoaded', function () {
  const sliderSection = document.querySelector('.custom-slider-section');
  if (!sliderSection) return;

  const slides = sliderSection.querySelectorAll('.custom-slider-container');
  const dots = sliderSection.querySelectorAll('.custom-slider-dot');
  const prevBtn = sliderSection.querySelectorAll('.custom-slider-arrow')[0];
  const nextBtn = sliderSection.querySelectorAll('.custom-slider-arrow')[1];
  const pauseBtn = sliderSection.querySelector('.custom-slider-pause');

  let currentSlide = 0;
  let autoPlay = true;
  let autoPlayInterval = null;

  function showSlide(index) {
    // For future: handle multiple slides
    slides.forEach((slide, i) => {
      slide.style.display = i === index ? 'flex' : 'none';
    });
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });
    currentSlide = index;
  }

  function nextSlide() {
    let next = (currentSlide + 1) % slides.length;
    showSlide(next);
  }

  function prevSlide() {
    let prev = (currentSlide - 1 + slides.length) % slides.length;
    showSlide(prev);
  }

  function startAutoPlay() {
    if (autoPlayInterval) clearInterval(autoPlayInterval);
    autoPlayInterval = setInterval(nextSlide, 5000);
  }

  function stopAutoPlay() {
    if (autoPlayInterval) clearInterval(autoPlayInterval);
    autoPlayInterval = null;
  }

  // Event listeners
  nextBtn.addEventListener('click', nextSlide);
  prevBtn.addEventListener('click', prevSlide);
  pauseBtn.addEventListener('click', function () {
    autoPlay = !autoPlay;
    if (autoPlay) {
      startAutoPlay();
      pauseBtn.innerHTML = '&#10073;&#10073;'; // Pause icon
      pauseBtn.setAttribute('aria-label', 'Pause slider');
    } else {
      stopAutoPlay();
      pauseBtn.innerHTML = '&#9654;'; // Play icon
      pauseBtn.setAttribute('aria-label', 'Play slider');
    }
  });
  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => showSlide(i));
  });

  // Initialize
  showSlide(currentSlide);
  if (autoPlay) startAutoPlay();
}); 